import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Action } from '../../../actions';
import { Api } from '../../../typings/api';
import { SharePanelMethod } from './reducer';
import { DriveItemInfo } from '../../DriveItemList/reducer';
import { getOrFetchDriveItemMeta } from '../../DriveItemList/actions';

export enum SharePanelActionKeys {
	REQUEST_OPEN = '@@sharePanel/REQUEST_OPEN',
	REQUEST_CLOSE = '@@sharePanel/REQUEST_CLOSE',
	SET_SELECTION = '@@sharePanel/SET_SELECTION',
	SET_METHOD = '@@sharePanel/SET_METHOD',
	SET_FORM_FIELD = '@@sharePanel/SET_FORM_FIELD',
	UPDATE_FOLDERS_CONTENT = '@@sharePanel/UPDATE_FOLDERS_CONTENT'
}

export interface RequestOpenAction extends Action {
	type: SharePanelActionKeys.REQUEST_OPEN;
}

export interface RequestCloseAction extends Action {
	type: SharePanelActionKeys.REQUEST_CLOSE;
}

export interface SetSelectionAction extends Action {
	type: SharePanelActionKeys.SET_SELECTION;
	selection: Api.DriveItem[];
}

export interface SetMethodAction extends Action {
	type: SharePanelActionKeys.SET_METHOD;
	method: SharePanelMethod;
}

export interface SetFormFieldAction extends Action {
	type: SharePanelActionKeys.SET_FORM_FIELD;
	name: string;
	value: string;
}

export interface UpdateFoldersContentAction extends Action {
	type: SharePanelActionKeys.UPDATE_FOLDERS_CONTENT;
	item: Api.DriveItem;
}

export type SharePanelAction =
	| RequestOpenAction
	| RequestCloseAction
	| SetSelectionAction
	| SetMethodAction
	| SetFormFieldAction
	| UpdateFoldersContentAction;

const addSubFoldersContent = (item: Api.DriveItem) => (dispatch: Dispatch<StoreState>, getState: () => StoreState) => {
	const { sharePanel } = getState();
	const { selection } = sharePanel;

	if (!selection.some(parent => parent.id === item.id)) {
		dispatch({
			type: SharePanelActionKeys.UPDATE_FOLDERS_CONTENT,
			item,
		});
	}
};

export const retrieveSubFoldersContent = (itemId: number) => (dispatch: Dispatch<StoreState>, getState: () => StoreState) => {
	dispatch(getOrFetchDriveItemMeta(itemId))
		.then((itemMeta: DriveItemInfo) => {
			const isFolder = itemMeta.type === Api.DriveItemType.Directory;

			if (isFolder) {
				const { resources } = itemMeta;
				if (resources) {
					resources.forEach(resource => dispatch(retrieveSubFoldersContent(resource.id)));
				}
			} else {
				dispatch(addSubFoldersContent(itemMeta));
			}
		});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/Panel/actions.ts